import config from './config';
import { handleResponse } from './handle-response';
import { checkToken, authHeader } from './helpers'

export const sponsorService = {
	list,
	retrieve
}

async function list() {
	await checkToken()
	const requestOptions = { method: 'GET', headers: authHeader() }
	return fetch(`${config.apiUrl}/sponsor/`, requestOptions)
		.then(handleResponse)
		.then(data => data)
}

async function retrieve(sponsorId) {
	await checkToken()
	const requestOptions = { method: 'GET', headers: authHeader() }
	return fetch(`${config.apiUrl}/sponsor/${sponsorId}/`, requestOptions)
		.then(handleResponse)
		.then(data => data)
}